import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/conversations/{conversationSid}/unread-message-ids';
type THIS_API = ApiDefinition['/conversations/{conversationSid}/unread-message-ids']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getUnreadMessageIds = async ({ conversationSid, lastViewedTimestamp }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { conversationSid });
  const response = await noodleApiClient.get(path, {
    params: lastViewedTimestamp ? { lastViewedTimestamp } : {},
  });
  return response.data;
};

export default getUnreadMessageIds;
